module.exports = __webpack_public_path__ + "img/流体力学4_5_1.b73c27ab.jpg";